<template>
  <div class="role-edit-json">
    <div class="modal role-edit-json-modal">
      <div class="modal-background" @click="closeModal" />
      <button class="modal-close is-large" @click="closeModal" />

      <div v-if="r" class="modal-card">
        <section class="modal-card-body">
          <span v-if="superuser" class="button is-danger is-small is-rounded"
            style="position:absolute; right:20px; top:10px; padding:5px 10px;" @click="preDeleteRole">
            <i class="fa fa-bomb" />&nbsp;Delete Role
          </span>
          <p class="subtitle is-4 has-text-grey" style="margin-bottom:8px">Edit Role JSON</p>
          <p class="has-text-weight-medium">{{ r.business.name }} - {{ r.workflow_name }} - {{ r.role_name }}</p>

          <div class="field">
            <div class="control">
              <textarea class="textarea is-info has-text-weight-medium" style="color:white; background-color:slategrey"
                :style="jsonStyle" v-model="dataJSON" placeholder="Data JSON" rows="20"></textarea>
            </div>
          </div>

          <div class="field has-addons">
            <p class="control">
              <button class="button is-medium is-warning" :class="{ 'is-danger': invalidJSON }" @click="parseJSON">
                <span class="icon">
                  <i class="fa fa-pencil-alt" />&nbsp;&nbsp;
                </span>Parse
              </button>
            </p>
            <p class="control is-expanded">
              <button class="button is-success is-fullwidth is-medium" @click="submit">Update</button>
            </p>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from "../eventBus.js";

export default {
  name: "RoleEditJSONModal",
  components: {},
  data() {
    return {
      r: null,
      dataJSON: null,
      invalidJSON: false
    };
  },
  computed: {
    jsonStyle() {
      if (this.invalidJSON) return "color:lightpink";
      return "color:#fffd00"; // light yellow
    },
    superuser() {
      return this.isSuperUser();
    }
  },
  mounted() {
    EventBus.$on("ROLE_EDIT_JSON_MODAL", r => {
      this.console("edit role json", r);
      this.r = r;
      this.dataJSON = JSON.stringify(r.data, null, 2);
    });
  },
  methods: {
    closeModal() {
      this.r = null; // reset role
      this.$el.querySelector(".modal").classList.remove("is-active");
    },
    prettyJSON(str) {
      return JSON.stringify(JSON.parse(str), null, 2);
    },
    isValidJSON() {
      try {
        JSON.parse(this.dataJSON);
      } catch (e) {
        this.invalidJSON = true;
        return false;
      }
      this.invalidJSON = false;
      return true;
    },
    parseJSON() {
      var loader = this.loadingDots("lightgreen");
      if (this.isValidJSON()) {
        this.dataJSON = this.prettyJSON(this.dataJSON);
      } else {
        console.log("invalid JSON");
      }
      setTimeout(() => loader.hide(), 200);
    },
    submit() {
      this.parseJSON();
      if (this.invalidJSON) {
        this.warningAlert("Invalid data JSON<br><br>Check keys are quoted.");
        return;
      }
      // console.log("updateRole", this.r);
      var loader = this.loadingDots("lightgreen");
      var data = JSON.parse(this.dataJSON);
      var payload = { id: this.r.id, data: data };
      this.$store
        .dispatch("updateRoleData", payload)
        .then(res => {
          this.console("updateRoleData", res);
          this.success();
          this.updateRoles(true);
          this.closeModal();
        })
        .catch(err => this.apiError(err))
        .finally(() => loader.hide());
    },
    preDeleteRole() {
      this.$swal({
        title: `<i class='fa fa-bomb' style='color:red' />`,
        text: `Are you sure you want to delete this role?`,
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: "Yes, delete it",
        confirmButtonColor: this.bulmaColor("danger")
      }).then(val => {
        if (val.value) this.deleteRole();
      });
    },
    deleteRole() {
      if (this.r.state === "working") {
        this.warningAlert("You must stop working before deleting your role!");
        return;
      }
      var loader = this.loadingDots();
      this.$store
        .dispatch("deleteRole", this.r.id) // should soft delete
        .then(() => this.updateRoles(true))
        .catch(err => console.error(err))
        .finally(() => {
          loader.hide();
          this.closeModal();
        });
    }
  }
};
</script>

<style scoped>
.modal-card-body {
  padding: 10px;
  text-align: left;
}

.field {
  margin-bottom: 4px;
}
</style>